export const searchVariantsOptions = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
  GLOBAL: 'global'
}
